module.exports = __webpack_public_path__ + "static/media/frustrerad.b7937337.mp3";